import { ResidenceType } from '../../../../common/residence'

export const residenceHasRooms = (residenceType?: ResidenceType) => ![
  ResidenceType.storageUnit5By5,
  ResidenceType.storageUnit5By10,
  ResidenceType.storageUnit10By20,
].includes(residenceType ?? '' as any)
